import React from "react";
import "../../../../styles/styles.css";
import video from "../../../../assets/video/video.mp4";
const Banner = () => {
  return (
    <video
      className="header-video"
      autoPlay
      loop
      muted
      playsInline
      src={video}
    />
  );
};
export default Banner;
